// Add event on document ready
$(document).ready(function () {
  $(window).scroll(function () {
    $('.count').each(function () {
      if ($(this).isOnScreen()) {
        startCounter($(this));
      } else {
        if ($(this).hasClass('not-inview') == false) {
          // Stop animation
          $(this).stop();
          // Add nonVisible class
          $(this).addClass('not-inview');
          // This stops the user very briefly seeing the previous number before the counter restarts
          $(this).text('0');
        }
      }
    });
  });
});

$.fn.isOnScreen = function () {
  var win = $(window);
  var viewport = {
    top: win.scrollTop(),
    left: win.scrollLeft(),
  };
  viewport.right = viewport.left + win.width();
  viewport.bottom = viewport.top + win.height();
  var bounds = this.offset();
  bounds.right = bounds.left + this.outerWidth();
  bounds.bottom = bounds.top + this.outerHeight();
  return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
};

//Run counter, separate function so we can call it from multiple places
function startCounter (counterElement) {
  if (counterElement.hasClass('not-inview')) {
    // Remove notVisible class
    counterElement.removeClass('not-inview');
    // Run your counter animation
    counterElement.prop('Counter', 0).animate({
      Counter: counterElement.attr('counter-lim'),
    }, {
      duration: 1200,
      easing: 'swing',
      step: function (now) {
        counterElement.text(Math.ceil(now).toLocaleString());
      },
    });
  }
}

// On page load check if counter is visible
$('.count').each(function () {

  // Add notVisible class to all counters
  // It is removed within startCounter()
  $(this).addClass('not-inview');

  // Check if element is visible on page load
  if ($(this).isOnScreen() === true) {

    // If visible, start counter
    startCounter($(this));

  }
});

// Animation for text/images elements by scrolling in view area
var $window = $(window);
const animationElementSelectors = [
  '.lazy',
  '.fadein',
  '.fadebottom',
  '.frame-narrow > .ce-textpic',
  '.frame-layout-0.frame-default > .ce-textpic',
  '.frame-section-leistungen > .ce-textpic',
  '.frame-section-aktuell > .ce-textpic',
  '.frame-leistung-gallery > div',
];
var $animationElements = $(animationElementSelectors.join(','));

function checkInView () {
  var window_height = $window.height();
  var window_top_position = $window.scrollTop();
  var window_bottom_position = (window_top_position + window_height);

  $.each($animationElements, function () {
    var $element = $(this);
    var element_height = $element.outerHeight();
    var element_top_position = $element.offset().top;
    var element_bottom_position = (element_top_position + element_height);

    // check to see if this current container is within viewport
    if ((element_bottom_position >= window_top_position) && (element_top_position <= window_bottom_position)) {
      $element.addClass('in-view');
    } else {
      $element.removeClass('');
    }
  });
}

$window.on('scroll resize', checkInView);
$window.trigger('scroll');
